import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';

export const EDIT_PAYMENT_ROUTING_FAILURE = 'PAYMENT_ROUTING/EDIT_PAYMENT_ROUTING_FAILURE';
export const EDIT_PAYMENT_ROUTING_LOAD = 'PAYMENT_ROUTING/EDIT_PAYMENT_ROUTING_LOAD';
export const EDIT_PAYMENT_ROUTING_SUCCESS = 'PAYMENT_ROUTING/EDIT_PAYMENT_ROUTING_SUCCESS';

export const PAYMENT_ROUTING_FAILURE = 'PAYMENT_ROUTING/PAYMENT_ROUTING_FAILURE';
export const PAYMENT_ROUTING_LOAD = 'PAYMENT_ROUTING/PAYMENT_ROUTING_LOAD';
export const PAYMENT_ROUTING_SUCCESS = 'PAYMENT_ROUTING/PAYMENT_ROUTING_SUCCESS';

export const fetchUrl = `${config.paymentApiUrl}/paymentRules`;

export function editPaymentRouting(user) {
    return {
        failureActionTypeOrCreator: editPaymentRoutingFailureActionCreator,
        fetchParams: {
            body: [user],
            method: 'POST',
            url: `${config.paymentApiUrl}/paymentRules`
        },
        loadActionTypeOrCreator: EDIT_PAYMENT_ROUTING_LOAD,
        successActionTypeOrCreator: EDIT_PAYMENT_ROUTING_SUCCESS
    };
}

export function editPaymentRoutingFailureActionCreator(error) {
    return {
        error,
        type: EDIT_PAYMENT_ROUTING_FAILURE
    };
}

export function getPaymentRoutingFailureActionCreator(error) {
    return {
        error,
        type: PAYMENT_ROUTING_FAILURE
    };
}

export function getPaymentRoutingSuccessActionCreator(results) {
    return {
        count: results.count,
        pages: Math.ceil(results.count / results.limit),
        rules: results.rows,
        type: PAYMENT_ROUTING_SUCCESS
    };
}

export function getPaymentRouting(filters, page, pageSize, sorters, users, columns) {
    const queryParamsString = createQueryParams({
        filters,
        users,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getPaymentRoutingFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: PAYMENT_ROUTING_LOAD,
        successActionTypeOrCreator: getPaymentRoutingSuccessActionCreator
    };
}
